import './FeaturesList.css';

import React, { useState } from "react";

import { Button, Icon, Pagination, Table } from 'semantic-ui-react';

import FeatureUpdate from './FeatureUpdate';


const FeaturesList = ({ selectedVersion, sites, activeFeature, activeProcess, onPageChange, onRemoveFeature,
    onRemoveFeatures, onSaveFeature, onSetActiveFeature, profile, configuration }) => {

    const featuresPerPage = 5;

    const handlePaginationChange = (e, data) => {
        onPageChange(selectedVersion.pk, data.activePage);
    }

    const [expandedRows, setExpandedRows] = useState([]);

    const handleExpandRow = (event, site) => {
        const currentExpandedRows = expandedRows;
        const isRowExpanded = currentExpandedRows.includes(site.pk);
    
        let obj = {};
        isRowExpanded ? (obj[site.pk] = false) :  (obj[site.pk] = true);

        const newExpandedRows = isRowExpanded ?
              currentExpandedRows.filter(id => id !== site.pk) :
              currentExpandedRows.concat(site.pk);
    
        setExpandedRows(newExpandedRows);
      }

    const getReducedName = (name) => {
        const max_size = 10;
        if (name.length > max_size) {
            return `${name.substring(0, max_size)}...`;
        } else {
            return name;
        }
    }

    const getAntennaTypeIcon = (site) => {
        if (site.is_sector) {
            const tooltip = `This is a ${site.sector_nodes} sector site with range ${site.sector_range}° (azimuth ${site.azimuth}°)`;
            return (
                <div data-tooltip={tooltip} data-inverted="">
                    <i aria-hidden="true" className="asterisk icon small"></i>
                </div>
            )
        }
        return (
            <div data-tooltip="This is a omni site" data-inverted="">
                <i aria-hidden="true"
                    className="circle icon small"
                ></i>
            </div>
        )
    }

    const getPopulationDetails = (site) => {
        return (
            <>
            <label>Population details for the selected process</label>
            <ul>
                <li>Total: {site.population_json.tot}</li>
                {Object.keys(site.population_json.countries).map((country, index) =>
                    <li>{country}: {site.population_json.countries[country].toLocaleString()}</li>
                )}
            </ul>
            <label>Population within a circle of {activeProcess.configuration.buffer_distance} km</label>
            <ul>
                {Object.keys(site.population_json.buffer).map((country, index) =>
                    <li>{country}: {site.population_json.buffer[country].toLocaleString()}</li>
                )}
            </ul>
            </>
        )
    }

    const getCoverageCompareDetails = (site) => {
        return (
            <>
            <label>Coverage Compare details</label>
            <ul>
                <li>Total population covered: {site.cc_total_pop_covered}</li>
                <li>Population already covered: {site.cc_pop_already_covered}</li>
                <li>Population not previously covered: {site.cc_pop_not_previously_covered}</li>
                <li>Population better covered: {site.cc_pop_better_covered}</li>
            </ul>
            </>
        )
    }

    const getFeatureDetails = (site) => {
        if(expandedRows.includes(site.pk)) {
            return (
                <Table.Row key={`${site.pk}_details`}>
                    <Table.Cell colSpan="7">
                    <label>Site Details</label>
                        <ul>
                            <li>Name: {site.name}</li>
                            <li>Type: {site.is_sector ? 'Sectored (' + site.sector_nodes + ' sectors)' : 'Omni'}</li>
                            <li>Height ({profile.units_length_string}): {site.height_local}</li>
                            <li>Transmit Power ({profile.units_power_string}): {site.txpwr_local}</li>
                            <li>Population: {site.population ? site.population.toLocaleString() : 'N/A'}</li>
                        </ul>
                        {site.population_json ? getPopulationDetails(site) : ''}
                        {site.cc_total_pop_covered != null ? getCoverageCompareDetails(site) : ''}
                    </Table.Cell>
                </Table.Row>
            )
        } 
    }

    if (!sites) {
        return <div></div>
    }
    if (selectedVersion.sites.length === 0) {
        return (
            <div>This collection has not sites.</div>
        )
    }

    return (

        <div>

            <Button icon
                onClick={onRemoveFeatures}
                disabled={selectedVersion.has_processes}
                data-tooltip="Remove all the sites for this sites collection"
                data-inverted=""
            >
                <Icon name='delete' />
            </Button>

            <Table id='table-sites' celled inverted selectable size='small'>

                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.HeaderCell>Site Name</Table.HeaderCell>
                        <Table.HeaderCell>Pop</Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                        <Table.HeaderCell>Info</Table.HeaderCell>
                        <Table.HeaderCell>Edit</Table.HeaderCell>
                        <Table.HeaderCell>Del</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>

                    {sites.map(site =>
                    <>
                        <Table.Row key={site.pk} 
                            active={activeFeature && site.pk === activeFeature} 
                            >
                            <Table.Cell
                                onClick={event => handleExpandRow(event, site)}
                            >
                                {
                                    expandedRows.includes(site.pk) ?
                                    <Icon name='angle up' /> : <Icon name='angle right' />
                                }
                            </Table.Cell>
                            <Table.Cell
                                data-tooltip={`Site: ${site.name} (version: ${site.version_number})`}
                                data-inverted=""
                            >
                                {getReducedName(site.name)}
                            </Table.Cell>
                            <Table.Cell>
                                {site.population ? site.population.toLocaleString() : 'N/A'}
                            </Table.Cell>
                            <Table.Cell>
                                {getAntennaTypeIcon(site)}
                            </Table.Cell>
                            <Table.Cell>
                                <button className="ui icon button mini"
                                    data-tooltip="Select this site on the map"
                                    data-inverted=""
                                    onClick={onSetActiveFeature.bind(this, site.pk)} >
                                    <i aria-hidden="true" className="info icon small"></i>
                                </button>
                            </Table.Cell>
                            <Table.Cell>
                                {configuration
                                    ?
                                    <FeatureUpdate
                                        feature={site}
                                        handleSubmit={onSaveFeature}
                                        profile={profile}
                                        configuration={configuration}
                                    />
                                    : <div></div>
                                }
                            </Table.Cell>
                            <Table.Cell>
                                <button className="ui icon button mini"
                                    data-tooltip="Remove this site"
                                    data-inverted=""
                                    onClick={onRemoveFeature.bind(this, site)}>
                                    <i aria-hidden="true" className="remove icon small"></i>
                                </button>
                            </Table.Cell>
                        </Table.Row>
                        <>
                        {getFeatureDetails(site)}
                        </>
                    </>
                    )
                    }

                </Table.Body>
            </Table>

            {selectedVersion.sites.length > featuresPerPage &&
                <Pagination
                    size='mini'
                    defaultActivePage={1}
                    totalPages={Math.ceil(selectedVersion.sites.length / 5)}
                    onPageChange={handlePaginationChange}
                />
            }

        </div>
    )
}

export default FeaturesList;
